/**
 * Contesto del tema chiaro/scuro.
 *
 * Tre stati, non due: «sistema» e' il valore di partenza e segue
 * `prefers-color-scheme`; «chiaro» e «scuro» sono scelte esplicite che vincono
 * sulla preferenza del sistema operativo e vengono ricordate.
 */

import { createContext, useContext } from "react";

export const TEMI = ["sistema", "chiaro", "scuro"] as const;
export type Tema = (typeof TEMI)[number];

export const ETICHETTE_TEMA: Record<Tema, string> = {
  sistema: "Tema di sistema",
  chiaro: "Tema chiaro",
  scuro: "Tema scuro",
};

export interface ValoreTema {
  tema: Tema;
  imposta: (tema: Tema) => void;
}

export const ContestoTema = createContext<ValoreTema | null>(null);

export function useTema(): ValoreTema {
  const valore = useContext(ContestoTema);
  if (!valore) throw new Error("useTema va usato dentro <FornitoreTema>.");
  return valore;
}
